import axios from 'axios';

// Create axios instance with default config
const chatApi = axios.create({
    baseURL: '/api', // Relative path to use proxy
    timeout: 10000, // 10 seconds timeout
    headers: {
        'Content-Type': 'application/json',
    }
});

// Response interceptor for error handling
chatApi.interceptors.response.use(
    (response) => response,
    (error) => {
        // Handle common errors (e.g. 429 Rate Limit)
        if (error.response && error.response.status === 429) {
            console.warn('Rate limit exceeded for chat');
        }
        return Promise.reject(error);
    }
);

// Helper to set auth token
export const setAuthToken = (token) => {
    if (token) {
        chatApi.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
        delete chatApi.defaults.headers.common['Authorization'];
    }
};

// Helper to start session
export const startSession = async (brandId, existingGuid) => {
    try {
        const response = await chatApi.post('/chat/start', {
            brandId,
            guid: existingGuid
        });

        if (response.data.success && response.data.token) {
            setAuthToken(response.data.token);
            return response.data;
        }
        throw new Error('Failed to start session');
    } catch (error) {
        console.error('Session start failed:', error);
        throw error;
    }
};

export default chatApi;
